<template>
  <v-dialog v-model="dialog" width="600px" persistent scrollable>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- Dialog for Comment Message Box -->
    <dialog-message-notifier
      :dialog="dialogMessageNotifierAdminCustomer"
      v-model="message_notifier_comment"
      v-on:dialog-close="onDialogCloseMessageNotifier"
    ></dialog-message-notifier>

    <v-card tile flat color="white" v-if="this.quotation_id != null">
      <v-card-title class="dialog-header-title">
        <v-row no-gutters>
          <v-col>
            <span class="font-weight-bold">{{ title }} Message Box</span>
          </v-col>

          <v-col cols="1" class="d-flex justify-content-end">
            <v-icon size="30" color="white" @click="onDialogClose">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="px-1">
        <template v-if="$root.is_admin">
          <v-row no-gutters>
            <v-col class="px-4 pt-4">
              <v-row>
                <v-textarea
                  class="modified-text-field caption mb-3"
                  label="Post comment"
                  dense
                  outlined
                  auto-grow
                  hide-details
                  rows="2"
                  row-height="25"
                  clearable
                  v-model="message"
                ></v-textarea>

                <v-btn
                  :disabled="message == null"
                  tile
                  class="font-weight-bold white--text ml-6 mt-2"
                  color="teal"
                  @click="postMessage"
                  >POST</v-btn
                >
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="my-0 mx-2"></v-divider>
        </template>

        <v-row v-if="sortedMessageList.length > 0" no-gutters>
          <v-col class="px-1 pt-1">
            <v-card tile flat color="white" class="pa-2" min-height="100">
              <template v-for="(comment, i) in sortedMessageList">
                <v-row :key="i">
                  <v-alert
                    :color="comment.category == 'quotation' ? 'teal' : 'primary'"
                    border="left"
                    elevation="3"
                    colored-border
                    tile
                    min-width="100%"
                    icon="mdi-message"
                    class="pb-0 pt-1 pr-1"
                  >
                    <v-row no-gutters>
                      <v-col>
                        <span class="caption font-weight-bold">{{
                          comment.message
                        }}</span>
                      </v-col>

                      <v-col cols="1" class="d-flex justify-content-end">
                        <v-icon
                          class="px-0"
                          :color="comment.category == 'quotation' ? 'teal' : 'primary'"
                          size="20"
                          @click="deleteMessage(comment)"
                          >mdi-close-circle-outline</v-icon
                        >
                      </v-col>
                    </v-row>

                    <v-row justify="space-between">
                      <span class="sub-comment-text pt-1">{{ comment.createdStr }}</span>
                      <v-chip
                        x-small
                        label
                        text-color="white"
                        :color="comment.category == 'quotation' ? 'teal' : 'primary'"
                        class="px-1 font-weight-bold"
                        >{{ comment.category }}</v-chip
                      >

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            x-small
                            icon
                            dark
                            v-on="on"
                            v-if="$root.is_admin"
                            @click="onMessageNotifierAdminCustomer(comment)"
                            :color="
                              comment.admin_notified || comment.customer_notified
                                ? 'success'
                                : 'primary'
                            "
                            ><v-icon>mdi-bell-ring</v-icon></v-btn
                          >
                        </template>
                        {{
                          comment.admin_notified || comment.customer_notified
                            ? "Notify admin or customer"
                            : "Notification sent"
                        }}
                      </v-tooltip>

                      <span class="sub-comment-text pt-1">{{ comment.first_name }}</span>
                    </v-row>
                  </v-alert>
                </v-row>
                <v-divider
                  v-if="messageList.length - 1 != i"
                  :key="`${i}divider`"
                  class="my-2"
                ></v-divider>
              </template>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else justify="center" class="mt-4">
          <v-alert icon="mdi-information" prominent text type="error"
            >No comment yet for {{ quotation_id }}</v-alert
          >
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";
import firebase from "firebase/app";
import "firebase/firestore";
import DialogMessageNotifier from "@/components/user/DialogMessageNotifier.vue";

export default {
  components: {
    DialogMessageNotifier,
  },
  props: [
    "value",
    "dialog",
    "quotation_id",
    "invoice_id",
    "title",
    "category",
    "company_id",
    "company_name",
    "tags",
  ],
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      collectionComments: "comments",
      collectionMessages: "messages",

      message: null,
      messageList: [],

      dialogMessageNotifierAdminCustomer: false,
      message_notifier_comment: null,
    };
  },
  created() {},
  mounted() {},
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.message = null;
        this.message_notifier_comment = null;
        this.fetchMessages();
      }
    },
  },
  methods: {
    /**
     * Fetch messages for this reference
     */
    fetchMessages() {
      this.messageList = [];
      this.$root.blockUImsg = "Loading messages...";
      this.$root.blockUIshow = true;
      var self = this;
      var db = this.$root.messageCenterApp.firestore();
      db.collection(this.collectionComments)
        .doc(this.quotation_id)
        .collection(this.collectionMessages)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            this.messageList.push(doc.data());
          });
          this.$root.blockUIshow = false;
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          self.showSnackbar = true;
          self.snackbarColor = "error";
          self.snackbarMsg = error;
          self.$root.blockUIshow = false;
        });
    },

    /**
     * Post message to firestore
     */
    postMessage() {
      this.$root.blockUImsg = "Posting message...";
      this.$root.blockUIshow = true;
      var self = this;
      var db = this.$root.messageCenterApp.firestore();
      var d = new Date();

      // compose the comment object
      let comment = {
        comment_id: null,
        quotation_id: this.quotation_id,
        invoice_id: this.invoice_id,
        category: this.category,
        company_id: this.company_id,
        company_name: this.company_name,
        tags: this.tags || [],
        message: this.message,
        first_name: this.$root.useraccount.first_name,
        last_name: this.$root.useraccount.last_name,
        email: this.$root.useraccount.email,
        uid: this.$root.useraccount.uid,
        account_type: this.$root.useraccount.account_type,
        restricted: false,
        admin_notified: false,
        customer_notified: false,
        createdStr: `${d.getFullYear()}-${
          d.getMonth() + 1
        }-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`,
        created: firebase.firestore.FieldValue.serverTimestamp(),
      };

      // write a new comment message
      db.collection(this.collectionComments)
        .doc(this.quotation_id)
        .collection(this.collectionMessages)
        .add(comment)
        .then((docRef) => {
          // update the comment to add the document id as the comment id
          comment.comment_id = docRef.id;
          // append comment to messageList
          this.messageList.push(comment);
          this.message = null;
          this.$root.blockUIshow = false;

          // update the comment id
          db.collection(this.collectionComments)
            .doc(this.quotation_id)
            .collection(this.collectionMessages)
            .doc(docRef.id)
            .update({
              comment_id: docRef.id,
            });

          // Get the doc for this quotation
          // TO check if this is the first comment message
          db.collection(this.collectionComments)
            .doc(this.quotation_id)
            .get()
            .then((doc) => {
              // if doc is empty
              if (!doc.exists) {
                // set the message count
                db.collection(this.collectionComments).doc(this.quotation_id).set({
                  count: 1,
                });
              } else {
                // update the message count
                db.collection(this.collectionComments)
                  .doc(this.quotation_id)
                  .update({
                    count: firebase.firestore.FieldValue.increment(1),
                  });
              }
            });
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
          self.showSnackbar = true;
          self.snackbarColor = "error";
          self.snackbarMsg = error;
          self.$root.blockUIshow = false;
        });
    },

    /**
     * Delete comment
     */
    deleteMessage(comment) {
      let confirmation = confirm("Are you sure you want to delete this message?");

      if (confirmation) {
        this.$root.blockUImsg = "Deleting message...";
        this.$root.blockUIshow = true;
        var self = this;
        var db = this.$root.messageCenterApp.firestore();
        db.collection(this.collectionComments)
          .doc(comment.quotation_id)
          .collection(this.collectionMessages)
          .doc(comment.comment_id)
          .delete()
          .then(() => {
            // remove the comment message from the list
            this.messageList = this.messageList.filter((item) => {
              return item != comment;
            });
            this.$root.blockUIshow = false;

            // update the message count
            db.collection(this.collectionComments)
              .doc(comment.quotation_id)
              .update({
                count: firebase.firestore.FieldValue.increment(-1),
              });
          })
          .catch(function (error) {
            console.error("Error removing document: ", error);
            self.showSnackbar = true;
            self.snackbarColor = "error";
            self.snackbarMsg = error;
            self.$root.blockUIshow = false;
          });

        this.$root.blockUIshow = false;
      }
    },

    /** on Notify admin or customer of message */
    onMessageNotifierAdminCustomer(comment) {
      this.dialogMessageNotifierAdminCustomer = true;
      this.message_notifier_comment = comment;

      // if admin or customer notify is null
      this.message_notifier_comment.admin_notified = comment.admin_notified || false;
      this.message_notifier_comment.customer_notified =
        comment.customer_notified || false;
    },

    /**
     * Close dialog
     */
    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_MESSAGE_BOX, null, null);
    },

    /**
     * on close the message box notifier
     */
    onDialogCloseMessageNotifier() {
      this.dialogMessageNotifierAdminCustomer = false;
      this.message_notifier_comment = null;
    },
  },
  computed: {
    sortedMessageList: function () {
      return this.messageList.sort(function (a, b) {
        return new Date(b.createdStr) - new Date(a.createdStr);
      });
    },
  },
};
</script>

<style scoped>
.v-input.v-text-field.modified-text-field {
  margin-top: 0px;
  padding-top: 0px;
  border: 0px !important;
  border-radius: 5px;
}

.v-alert {
  z-index: 1;
}
</style>
